(function($) {

$(function() {
    $('.hide-instructions').click(function(event) {
        event.preventDefault();
        var $sender = $(this);
        var $instructions = $sender.closest('.instructions');
        $instructions.hide();
        $.ajax('/account/option', {
            data: {
                hide_instructions: true
            },
            success: function(data, status) {
                console.log(data);
            }
        });
    });
    $('.hide-agreement').click(function(event) {
        event.preventDefault();
        var $sender = $(this);
        var $instructions = $sender.closest('.agreement');
        $instructions.hide();
        var d = new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        $.ajax('/account/option', {
            data: {
                agreed_at: [year, month, day].join('-')
            },
            success: function(data, status) {
                console.log(data);
            }
        });
    });
});

})(jQuery);
